import { Http } from "../Http";
export class UserAPI {
  public static saveUser(input: any) {
 
    var obj = JSON.stringify(input);
 
 
    var url = '/api/users/';
    if(input.id!==0 && input.id>0){
      url = '/api/updateUsers/';
      var userInputInit={
        id:input.id,
      first_name:input.first_name,
      middle_name:input.middle_name,
      last_name:input.last_name,
      sex:input.sex,
      dob :input.dob,
      address1:input.address1,
      address2:input.address2,
      country:input.country,
      state:input.state,
      city:input.city,
      zipcode:input.zipcode,
      emailId:input.emailId,
      countryCode:input.countryCode,
      mobileNumber:input.mobileNumber,
      updatedBy:input.lastModifiedBy,  
      }
      obj = JSON.stringify(userInputInit);
    }
 
    if (input.emailid !== null && input.emailid !== "") {
   
      const resultMethod = Http.axios().post(url, obj,
        {
          headers: {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "*",
            "Access-Control-Allow-Headers": "*"
          }
        })
        .then(res => {
             return res;
        }).catch((e: any) => {
             return e.response;
        }); 
      return resultMethod;
    }
  }


  public static updateStaus(input: any) {
   
   
    var url = 'api/changeUserStatus/'+input;
   
      const resultMethod = Http.axios().post(url, 
        {
          headers: {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "*",
            "Access-Control-Allow-Headers": "*"
          }
        })
        .then(res => {
 
          return res;
        }).catch((e: any) => {
 
          return e.response;
        });
      return resultMethod;    
  }
  
  public static getUsersList(input: any) {
    var url = "/api/userProfileByTenant/" + input;
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;
  }

  public static userDetailByTenant(input: any) {
    var url = "/api/getAllEmployeeInfoDetails/" + input.input;

    if (input === "") {
      return { data: [] };
    }
    
    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
      //  alert(JSON.stringify(res));
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;
  }

  public static  getallCompanyAdditionalDetails(input: any){
    // getallCompanyAdditionalDetails
      var url = "api/userDetailByTenant/" + input.input;
   //  alert("getCompanyDetails  url "+url);
  //   alert(JSON.stringify(input)); 
      if (input === "") {
        return { data: [] };
      }
  
      const resultMethod = Http.axios()
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          }
        })
        .then(res => {
      //    alert(JSON.stringify(res));
          return res;
        })
        .catch((e: any) => {
          return e.response;
        });
      
      return resultMethod;  
  }

  public static  getPdfView(input: any){
    // getallCompanyAdditionalDetails
      var url = "api/terms-conditions/";
   //  alert("getCompanyDetails  url "+url);
  //   alert(JSON.stringify(input)); 
      if (input === "") {
        return { data: [] };
      }
  
      const resultMethod = Http.axios()
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Response-Type": "blob", 
          }
        })
        .then(res => {   
          const report = new Blob([res.data])
          const reportUrl = URL.createObjectURL(report)
          window.open(reportUrl, "_blank") 
       return res;
        })
        .catch((e: any) => {
          return e.response;
        });
      
      return resultMethod;  
  }
  
}